const Question = {

    // FIELDS
    "question_bank": "Question Bank",
    "question": "Question",
    "question_type": "Question Type",
    "question_level": "Question Level",
    "options": "Options",
    "option_text": "Option",
    "is_correct": "Is Correct",
    "question_image": "Question Image",
    "option_image": "Option Image",
    "add_option": "Add Option",
    "search": "Search",

    // PAGE HEADER
    "question_title": "Question",

    // ERROR
    "error_question_bank": "Select Question Bank",
    "error_question": "Enter Question",
    "error_type": "Select Question Type",
    "error_level": "Select Question Level",
    "error_answer": "Enter Answer",
    "error_options": "Add at least 2 options",
    "error_max_options": "Maximum 5 options allowed",
    "error_correct_answer": "Select at least one correct answer",

    // TABLE HEADER
    "table_question": 'QUESTION',
    "table_type": 'TYPE',
    "table_level": 'LEVEL',
    "table_bank": 'QUESTION BANK',

    // IMPORT
    "import_question": "Import Questions",
    "import_help": "Upload a CSV or XLSX file with columns: question_bank_id, question_type, question_level, question_text, option_1, option_2, option_3, option_4, option_5, correct_options (comma-separated option numbers that are correct).",
    "download_template": "Download Template",
    "import_file": "Import File",
    "error_import_file": "Please choose a CSV or XLSX file",
    "total_rows": "Total Rows",
    "imported": "Imported",
    "failed": "Failed",
    "row": "Row",

}

export default Question;
